import React, { ReactElement } from "react";
import { Checkbox } from "@mui/material";
import inputsValidation from "../../messages/inputValidation";
import "./../../style/forms.scss";
import "./../../style/alerts.scss";
interface IProps {
  name: string;
  field: object;
  title: ReactElement;
  description?: ReactElement;
  errors: any;
}

const CheckBoxInput: React.FC<IProps> = ({ field, name, title, description, errors }: IProps) => {
  return (
    <div className="checkboxInput" id={`checkbox-${name}`}>
      <div className="one-checkbox">
        <Checkbox {...field} className="checkbox-input" />
        <span>{title}</span>
      </div>
      {description && <p>{description}</p>}
      {errors[name] && (
        <div style={{ margin: "auto", width: "80%" }} className="alert alert-red">
          *{inputsValidation(errors, name)}
        </div>
      )}
    </div>
  );
};

export default CheckBoxInput;
